import React, { useEffect, useState } from 'react'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import styled from 'styled-components'

const NAVIGBTN = styled.button`
outline: none;
border:none;

margin-top: 80vh;
 @media screen and (max-width:48rem) {
    margin-left: 80%;
}
@media screen and (min-width:48rem) {
    margin-left: 90%;
}
`
const NavigBtn = () => {
    const[nvBtnVal, setNBV] = useState('Down');

    const handleNavBtn = () => {
        if(nvBtnVal === 'Down') {
            
            setNBV('Top')
        }
       else setNBV('Down')
    }

    useEffect(() => {
        window.addEventListener('scroll', e => {
            if(window.scrollY >= 0.5 * window.innerHeight) {
                 setNBV('Top')
                
            } else {
                setNBV('Down')

            }
        })
    })
    return ( 
        <>
<a style={{textDecoration:'none', color:'white'}} href={nvBtnVal === 'Down' ? '#top' : '#down'}>

 <NAVIGBTN style={{borderRadius:'50%', background:'#261431', color:'white', padding:'1rem', position:'fixed', zIndex:'4', fontSize:'small',cursor:'pointer'}} onClick={handleNavBtn}>{nvBtnVal === 'Top' ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
</NAVIGBTN>

</a> 

        </>
     );
}
 
export default NavigBtn;